import React, { createContext, useContext, useMemo } from 'react';
import T from '../i18n/translations';
import { useAuth } from './AuthContext';

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const { user } = useAuth();
  const lang = (user?.lang && T[user.lang]) ? user.lang : 'de';

  const value = useMemo(() => ({
    lang,
    t: key => T[lang][key] ?? T['de'][key] ?? key,
    months: () => T[lang].months,
  }), [lang]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
